import { render, staticRenderFns } from "./ModelSelector.vue?vue&type=template&id=09c59640&scoped=true"
import script from "./ModelSelector.vue?vue&type=script&lang=js"
export * from "./ModelSelector.vue?vue&type=script&lang=js"
import style0 from "./ModelSelector.vue?vue&type=style&index=0&id=09c59640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c59640",
  null
  
)

export default component.exports